import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — forces the browser to scroll to the top of the viewport
 * whenever the route changes. Without this, react-router preserves the scroll
 * position which means navigating from a long Kundli page to /chat keeps the
 * user scrolled half-way down a different page.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
